import React, { useEffect } from 'react';
import FeaturesCard from './subcomponents/FeaturesCard';
import { IoSpeedometerOutline } from 'react-icons/io5';
import { GoGraph } from 'react-icons/go';
import { BiCookie } from 'react-icons/bi';
import { AiOutlineGift } from 'react-icons/ai';
//gsap happens
import { gsap, Power3 } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);

function Features() {
  useEffect(() => {
    gsap.from('.features_card', {
      duration: 1,
      y: '10',
      scale: 0.3,
      opacity: 0,
      ease: Power3.easeInOut,
      scrollTrigger: {
        trigger: '.features',
        start: 'top 70%',
        end: 'bottom 30%',
        // markers: true,
        toggleActions: 'play none none reverse',
        // delay: 0.5,
      },
      stagger: 0.2,
    });
  }, []);
  const features = [
    {
      svg: <IoSpeedometerOutline />,
      title: '30 - 70% increase',
      title2: 'in performance',
      subtitle: 'High CTR 0.75% - 5%',
      subtitle2: '',
    },
    {
      svg: <GoGraph />,
      title: '30x Ad-engagement &',
      title2: 'high visibility',
      subtitle: 'ONE Market significantly raises',
      subtitle2: 'Ad engagements',
    },
    {
      svg: <BiCookie />,
      title: 'Cookie-free &',
      title2: '100% GDPR compliant',
      subtitle: 'No PII is used.',
      subtitle2: 'ONE Market targets behaviours.',
    },
    {
      svg: <AiOutlineGift />,
      title: 'Free',
      title2: 'to license',
      subtitle: 'Designed as a plug and play platform.',
      subtitle2: 'No fee or charges.',
    },
  ];

  return (
    <>
      <section id='#feature' className='features d-flex justify-content-center'>
        <div className='features_container d-flex justify-content-between'>
          {features.map((feat, index) => (
            <div
              index={index}
              className='features_card  d-flex-col gap-1 align-items-center text-center'
            >
              <FeaturesCard
                svg={feat.svg}
                title={feat.title}
                title2={feat.title2}
                subtitle={feat.subtitle}
                subtitle2={feat.subtitle2}
              />
            </div>
          ))}
        </div>
      </section>
    </>
  );
}

export default Features;
